import React, {useEffect} from 'react'
import './home.css'
import Main from "./main/Main";
import {useHistory} from "react-router-dom";

function Home() {

    let history = useHistory();

    useEffect(() => {
      history.push('/main/login');
    }, [])

    return (
        <div className={'home-container'}>
            <Main className="main-container"/>
        </div>
    )
}

export default Home
